// What's going out and when: scheduled email and SMS campaigns (from the
// campaigns list the hub uses) alongside planned posts, for the calendar and
// the diary's Today chip.
import moment from 'moment'
import { marketingApiService } from '../../../services/marketingApiService'
import { isDue, sameDay } from './store'

let cache = null // { at, list }
const FRESH_MS = 5 * 60 * 1000

const whenOf = (c) => {
  if (!c.scheduledDate) return null
  const day = moment(c.scheduledDate)
  if (!day.isValid()) return null
  const [h, m] = String(c.scheduledTime || '').split(':').map(Number)
  if (Number.isFinite(h)) day.hours(h).minutes(Number.isFinite(m) ? m : 0)
  return day.toDate()
}

export const loadScheduledCampaigns = async (dispatch, { force = false } = {}) => {
  if (!force && cache && Date.now() - cache.at < FRESH_MS) return cache.list
  const channels = ['email', 'sms']
  const pages = await Promise.all(channels.map(type => marketingApiService
    .getCampaignsPaged(dispatch, { type, currentPage: 1, limit: 50, status: 'scheduled' })
    .then(r => (r.campaigns || []).map(c => ({ ...c, channel: type })))
    .catch(() => [])))
  const list = pages.flat()
    .map(c => ({ id: c.id || c._id, name: c.name || 'Campaign', channel: c.channel, at: whenOf(c) }))
    .filter(c => c.at)
    .sort((a, b) => a.at - b.at)
  cache = { at: Date.now(), list }
  return list
}

// Today's reminders: posts due and campaigns sending today
export const todayItems = (posts, campaigns, now = new Date()) => {
  const due = posts.filter(p => p.status === 'planned' && p.plannedAt && (isDue(p, now) || sameDay(new Date(p.plannedAt), now)))
  const sending = (campaigns || []).filter(c => sameDay(c.at, now))
  return { due, sending }
}
